export default "__VITE_ASSET__Cguev5SQ__"